export * from './post-feld-kategorie-request.interface';
export * from './post-feld-kategorie-response.interface';
export * from './post-feld-kategorie.shapes';
